export const reportInvoicesGroupedTypes = {
  SET_INVOICES_GROUPED_FILTERS: 'REPORT_INVOICES_GROUPED/SET_FILTERS',
  RESTORE_INITIAL: 'REPORT_INVOICES_GROUPED/RESTORE_INITIAL'
};

export const reportInvoicesGroupedLoadings = {
  GET_REPORT: 'loadingInvoicesGrouped',
};
